// removed by extract-text-webpack-plugin
module.exports = {"icon-style":"flatbutton-module-icon-style-331799ae661627808a9c10fe37c96a39--"};


//////////////////
// WEBPACK FOOTER
// /src/components/UiComponents/FlatButton/flatbutton.module.scss
// module id = 1938
// module chunks = 0